import React from 'react';
import './IndicatorSummary.css';
import Indicator from 'components/Indicator/Indicator';
import Tab from 'react-bootstrap/Tab';
import { Row, Col, Nav } from 'react-bootstrap';
import 'bootstrap/dist/css/bootstrap.min.css';
import indicatorGroups from 'data/indicatorGroups.json';
import indicatorsData from 'data/indicatorsData.json';
import translations from 'data/translations.json';
import GetAppIcon from '@material-ui/icons/GetApp';
import PictureAsPdfIcon from '@mui/icons-material/PictureAsPdf';
import { MobileDeviceContext } from 'lib/Screen';

class IndicatorSummary extends React.Component {
    onCategoryClick(e) {
        e.preventDefault();
        var target = document.getElementById("jumpTarget");
        if (target.classList.contains("mobile") || window.innerWidth <= 1000) {
            target.scrollIntoView(true);
            //window.location.href = "#jumpTarget";
        }
    }

    render() {
        const isMobile = this.context;

        return (
            <Tab.Container defaultActiveKey={indicatorGroups.length > 0 ? indicatorGroups[0].group : ""}>
                <Row className={isMobile ? "mobile" : ""}>
                    <Col sm={3} className={isMobile ? "mobile" : ""}>
                        <Nav variant="pills" className="flex-column">
                            {
                                indicatorGroups.map(navEntry => (
                                    <Nav.Item key={`nav-${navEntry.group}`}>
                                        <Nav.Link eventKey={navEntry.group} onClick={this.onCategoryClick}>
                                            <img className="groupIcon" src={navEntry.icon} alt="icon"></img>
                                            <div className="groupTitle">{translations[navEntry.group][window.lang].toUpperCase()}</div>
                                        </Nav.Link>
                                    </Nav.Item>
                                ))
                            }
                        </Nav>
						
                        <Nav variant="pills" className="flex-column">
                            <Nav.Item key="">
                                <a href={window.lang=="de" ? "report/ASTATECO_de.pdf" : "report/ASTATECO_it.pdf"} target="_blank" rel="noopener noreferrer" className="reportDownloadTab">
                                    <PictureAsPdfIcon className="groupIcon" />
                                    <div className="groupTitle">{translations.reportDownload[window.lang].toUpperCase()}</div>
                                </a>
                            </Nav.Item>
                        </Nav>
						
                        <Nav variant="pills" className="flex-column">
                            <Nav.Item key="">
                                <a download href="download/ASTAT_DATA.csv" className="fullDownloadTab">
                                    <GetAppIcon className="groupIcon" />
                                    <div className="groupTitle">{translations.fullDownload[window.lang].toUpperCase()}</div>
                                </a>
                            </Nav.Item>
                        </Nav>
                    </Col>
                    
                    <Col sm={9} className={isMobile ? "mobile" : ""} id="jumpTarget">
                        <Tab.Content>
                            {
                                indicatorGroups.map(navEntry => (
                                    <Tab.Pane eventKey={navEntry.group} key={`group-${navEntry.group}`}>
                                        {
                                            navEntry.members.map(member => (<Indicator info={indicatorsData[navEntry.group].find(entry => entry.code === member)} key={`content-${member}`} />))
                                        }
                                    </Tab.Pane>
                                ))
                            }
                        </Tab.Content>
                    </Col>
                </Row>
            </Tab.Container>
        );
    }
}

IndicatorSummary.contextType = MobileDeviceContext;

export default IndicatorSummary;